import {
  getApiUrl,
  getMerchantsFacilitiesFacilityPublicIDLogoPath,
} from "Infrastructure/Api/Api";
import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";

type Props = {
  merchantPublicID: string;
  facilityPublicID: string;
  enabled?: boolean;
};

export const useGetFacilityLogoQuery = ({
  merchantPublicID,
  facilityPublicID,
  enabled,
}: Props) => {
  const { dataUpdatedAt } = useGetMerchantQuery(merchantPublicID);

  const logoUrl = enabled
    ? `${getApiUrl()}${getMerchantsFacilitiesFacilityPublicIDLogoPath(facilityPublicID)}?v=${dataUpdatedAt}`
    : undefined;

  return { logoUrl };
};
